import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updatePageStatus } from 'redux/actions/ui.action';
import backgroundMySession from 'static/svg/bg-topic-detail.svg';
import Section from 'views/components/core/Section';
import './custom-home.scss';
import CardMvpSession from "../../components/core/CardSession";

import {
  getCategorySessions,
  getListBuddyRole,
  getListStatusSession,
  getMySessions,
  fetchNeedEvaluateSessions,
} from 'redux/actions/mvp/session.action';
import RatingFloatNotification from '../../components/core/RatingFloatNotification';
import { PageHero, PageLoader } from '@kambria/kambria-lego';
// import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// import { DotLottie } from '@lottiefiles/dotlottie-web';
// import animate from 'static/animation.lottie'

import config from 'config';
import Pagination from "../../components/core/Pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ConfigProvider, DatePicker, Select } from 'antd';
import en_US from 'antd/es/locale/en_US';
import vi_VN from 'antd/es/locale/vi_VN';
import moment from 'moment/moment';
import debounce from 'lodash/debounce';
import _ from 'lodash';
import { I18n } from '../../../helpers/i18n';

const locale = I18n.language === 'vi' ? vi_VN : en_US;

class MySession extends React.Component {
  constructor() {
    super();
    this.state = {
      visibleMembershipModal: false,
      currentPage: 1,
      totalRecords: 0,
      pageLimit: 12,
      listSessions: [],
      listStatus: [],
      filterKeySearch: '',
      categories: [],
      categoriesLevel1: [],
      categoriesLevel2: [],
      roles: [],
      filterCategories: [],
      filterCategoryLevel1: null,
      filterCategoryLevel2: [],
      rawCategoryLevel2: null, // Store raw categoryLevel2 from URL for invalid IDs
      filterStatus: [],
      filterEvaluating: [],
      filterRole: null,
      filterCreateDate: null,
      filterLanguage: [],
      openFilterCreateDate: false,
      startDate: null,
      endDate: null,
      evaluating: [],
      createDate: [],
      languages: [],
      isChangingCategoryLevel1: false, // Flag to prevent filter trigger when setting level 2 after categoryLevel1 change
      currentI18nLanguage: I18n.language || 'vi',
      pendingRatingSession: null,
    };
    // Track all timeouts for cleanup
    this.timeouts = [];
    this._isMounted = false;
  }

  // Helper method to safely set timeout and track it
  safeSetTimeout = (callback, delay) => {
    const timeoutId = setTimeout(() => {
      if (this._isMounted) {
        callback();
      }
    }, delay);
    this.timeouts.push(timeoutId);
    return timeoutId;
  }

  // Cleanup all timeouts
  clearAllTimeouts = () => {
    this.timeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.timeouts = [];
  }

  // Safe setState that checks if component is still mounted
  safeSetState = (state, callback) => {
    if (this._isMounted) {
      this.setState(state, callback);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.clearAllTimeouts();
    // Cancel debounced function if it exists
    if (this.handleChangeDebounced && this.handleChangeDebounced.cancel) {
      this.handleChangeDebounced.cancel();
    }
  }

  style = {
    backgroundImage: `url(${backgroundMySession})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    minHeight: '1px'
  };

  async componentDidMount() {
    this._isMounted = true;
    document.title = "CED - Kết nối yêu thương giữa các thế hệ";
    this.props.updatePageStatus('loading');
    this.safeSetTimeout(() => {
      if (this._isMounted) {
        this.setState({
          evaluating: [
            { value: 1, key: 1, label: I18n.t('from_one_star') },
            { value: 2, key: 2, label: I18n.t('from_two_star') },
            { value: 3, key: 3, label: I18n.t('from_three_star') },
            { value: 4, key: 4, label: I18n.t('from_four_star') },
            { value: 5, key: 5, label: I18n.t('five_star') },
          ],
          createDate: [
            { value: 'today', label: I18n.t('today') },
            { value: 'yesterday', label: I18n.t('yesterday') },
            { value: 'thisWeek', label: I18n.t('this_week') },
            { value: 'sevenDaysAgo', label: I18n.t('7_days_ago') },
            { value: 'other', label: I18n.t('range_calendar') },
          ]
        });
      }
    }, 0)
    const { getMySessions, getCategorySessions, getListStatusSession, getListBuddyRole } = this.props;
    const params = this.mapUrlToFilter();
    const newState = {};
    if (this.props.listLanguage?.length) {
      // Map language labels according to current website language
      const currentLanguage = I18n.language || 'vi';
      newState.languages = this.props.listLanguage.map(item => {
        let label = item.label;
        // If current website language is Vietnamese, show Vietnamese labels
        if (currentLanguage === 'vi') {
          label = item.value === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh';
        } else {
          // If current website language is English, show English labels
          label = item.value === 'en' ? 'English' : 'Vietnamese';
        }
        return {
          key: item.value,
          value: item.value,
          label: label,
        };
      });
      newState.currentI18nLanguage = currentLanguage;
    }
    let categories = [], arrStatus = [], roles = [], sessions = []
    if (Object.keys(params).length) {
      [categories,
        arrStatus,
        roles] = await Promise.all([
        getCategorySessions(),
        getListStatusSession(),
        getListBuddyRole(),
      ]);
    } else {
      [categories,
        sessions,
        arrStatus,
        roles] = await Promise.all([
        getCategorySessions(),
        getMySessions({ page: 1, limit: this.state.pageLimit }),
        getListStatusSession(),
        getListBuddyRole(),
      ]);
    }
    arrStatus = arrStatus?.data || []
    arrStatus = arrStatus.map(item => ({
      key: item.value,
      value: item.value,
      label: item.label,
    }))
    
    // Process categories with level 1 and level 2 structure
    // API already returns name in the correct language based on accept-language header
    const categoriesLevel1 = categories?.map(item => ({
      key: item._id,
      value: item._id,
      label: this.getCategoryLabel(item),
    })) || [];
    
    // Keep full categories structure for level 2
    const categoriesWithChildren = categories || [];

    const { categoryId, categoryLevel1, categoryLevel2, evaluating, keySearch, startDate, endDate, status, role, language, page } = params;

    // Set language filter: if in URL params, use it; otherwise default to all languages
    if (language) {
      const languageIds = language.split(',');
      const languageOptions = newState.languages?.filter(lang => languageIds.includes(lang.value)) || [];
      if (languageOptions.length > 0) {
        newState.filterLanguage = languageOptions;
      }
    } else if (newState.languages && newState.languages.length > 0) {
      // Default: select all languages
      newState.filterLanguage = newState.languages;
    }

    // Handle category level 1 and level 2 from URL
    const categoryLevel1Id = categoryLevel1;
    const categoryLevel2Id = categoryLevel2;
    
    if (categoryLevel1Id) {
      const level1Category = categoriesLevel1.find(cat => cat.key === categoryLevel1Id);
      if (level1Category) {
        const selectedCategory = categoriesWithChildren.find(cat => cat._id === categoryLevel1Id);
        if (selectedCategory && selectedCategory.children) {
          // Set level 1
          newState.filterCategoryLevel1 = level1Category;
          // Set level 2 - if URL has level2, use it, otherwise select all
          // Treat empty string the same as null/undefined - default to all level 2
          if (categoryLevel2Id && categoryLevel2Id.trim() !== '') {
            // Store raw value for API calls even if IDs are invalid
            newState.rawCategoryLevel2 = categoryLevel2Id;
            const level2Ids = categoryLevel2Id.split(',');
            const level2Options = selectedCategory.children
              .filter(child => level2Ids.includes(child._id))
              .map(child => ({
                key: child._id,
                value: child._id,
                label: this.getCategoryLabel(child),
              }));
            // If no matches found, keep raw value for API, otherwise use matched options
            newState.filterCategoryLevel2 = level2Options.length > 0 ? level2Options : [];
          } else {
            // Default: select all level 2
            const allLevel2 = selectedCategory.children.map(child => ({
              key: child._id,
              value: child._id,
              label: this.getCategoryLabel(child),
            }));
            newState.filterCategoryLevel2 = allLevel2;
            newState.rawCategoryLevel2 = null;
          }
          newState.categoriesLevel2 = selectedCategory.children.map(child => ({
            key: child._id,
            value: child._id,
            label: this.getCategoryLabel(child),
          }));
        }
      }
    }
    
    // Legacy support for categoryId (backward compatibility)
    if (categoryId && !categoryLevel1Id) {
      const cateIds = categoryId.split(',');
      const cateInfo = categoriesLevel1.filter(obj => cateIds.includes(obj.key));
      // Set directly to newState instead of calling handleSelectMulti to avoid triggering componentDidUpdate
      newState.filterCategories = cateInfo;
    }

    if (status) {
      const fStatus = status.split(',');
      // Map is_processing to processing for compatibility with API status list
      const mappedStatus = fStatus.map(s => s === 'is_processing' ? 'processing' : s);
      const fStatusInfo = arrStatus.filter(obj => mappedStatus.includes(obj.key));
      // Set directly to newState instead of calling handleSelectMulti to avoid triggering componentDidUpdate
      newState.filterStatus = fStatusInfo;
    } else {
      // If no status in URL params, select all statuses by default
      if (arrStatus.length > 0) {
        newState.filterStatus = arrStatus;
      }
    }

    if (evaluating) {
      const fEvaluating = evaluating.split(',');
      const data = this.state.evaluating.filter(obj => fEvaluating.includes(String(obj.key)));
      // Set directly to newState instead of calling handleSelectMulti to avoid triggering componentDidUpdate
      newState.filterEvaluating = data;
    }

    if (role) {
      const data = roles.filter(obj => obj.value === role);
      // Set directly to newState instead of calling handleSelect to avoid triggering componentDidUpdate
      newState.filterRole = data.length > 0 ? data[0] : null;
    }

    if (keySearch) {
      newState.filterKeySearch = keySearch;
    }

    if (startDate || endDate) {
      this.handleSelectCreateDate({ value: 'other', label: I18n.t('range_calendar'), key: 'other' });
      if (startDate) this.handleStartTime(moment(Number(startDate)));
      if (endDate) this.handleEndTime(moment(Number(endDate)));
    }

    newState.categories = categoriesLevel1;
    newState.categoriesLevel1 = categoriesLevel1;
    newState.categoriesWithChildren = categoriesWithChildren;
    newState.roles = roles;
    newState.listStatus = arrStatus;
    if (sessions?.success) {
      const data = sessions.data.data;
      newState.listSessions = data.list || [];
      newState.currentPage = data.currentPage || 1;
      newState.totalRecords = Number(data.total) || 0;
    }
    
    // Set state first, then apply filter if needed
    this.safeSetState(newState, async () => {
      if (!this._isMounted) return;
      
      // Update filter labels after state is set
      if (newState.filterStatus && newState.filterStatus.length > 0 && !status) {
        // Update label for filterStatus if it was set by default (no status in URL)
        this.safeSetTimeout(() => {
          if (this._isMounted) {
            this.updateFilterLabel('filterStatus', I18n.t('dashboard_filter_status'));
          }
        }, 100);
      }
      
      // Update label for category level 2 filter if it was set from URL
      if (newState.filterCategoryLevel2 && newState.filterCategoryLevel2.length > 0) {
        this.safeSetTimeout(() => {
          if (this._isMounted) {
            this.updateFilterLabel('filterCategoryLevel2', I18n.t('session_category_level2') || 'Sub Category');
          }
        }, 100);
      }
      
      // Update label for language filter if it was set by default (all languages)
      if (newState.filterLanguage && newState.filterLanguage.length > 0 && !language) {
        this.safeSetTimeout(() => {
          if (this._isMounted) {
            this.updateFilterLabel('filterLanguage', I18n.t('language'));
          }
        }, 100);
      }
      
      // If no URL params, apply filter with all statuses and all languages selected by default
      const hasUrlParams = categoryId || categoryLevel1 || evaluating || role || status || keySearch || language || startDate || endDate;
      if (!hasUrlParams) {
        // No URL params, but we have all statuses and all languages selected by default, so fetch sessions
        // Don't send status or language parameter to API to get all sessions (all statuses and all languages)
        const fetchParams = { page: 1, limit: this.state.pageLimit };
        const sessions = await getMySessions(fetchParams);
        if (this._isMounted && sessions?.success) {
          const data = sessions.data.data;
          const allSessions = data.list || [];
          this.safeSetState({
            listSessions: allSessions,
            currentPage: data.currentPage || 1,
            totalRecords: Number(data.total) || 0,
          });
        }
      } else {
        // Has URL params, fetch sessions with current URL params
        const currentParams = this.mapUrlToFilter();
        
        // Build params for API call (map processing to is_processing for API)
        const apiParams = { ...currentParams };
        
        // Use filterCategoryLevel1 from state if available (processed category), otherwise use URL value
        // Always ensure categoryLevel1 from URL is included if it exists
        if (newState.filterCategoryLevel1) {
          apiParams.categoryLevel1 = newState.filterCategoryLevel1.value;
        } else if (currentParams.categoryLevel1) {
          // categoryLevel1 in URL but not processed (category not found), use URL value
          apiParams.categoryLevel1 = currentParams.categoryLevel1;
        }
        // Prioritize categoryLevel1 over categoryId
        if (apiParams.categoryLevel1) {
          delete apiParams.categoryId;
        }
        
        // Use filterCategoryLevel2 from state if available, otherwise use raw value or URL value
        if (newState.filterCategoryLevel2 && newState.filterCategoryLevel2.length > 0) {
          apiParams.categoryLevel2 = newState.filterCategoryLevel2.map(c => c.value).join(',');
        } else if (newState.rawCategoryLevel2 && newState.rawCategoryLevel2.trim() !== '') {
          // Use raw value if filterCategoryLevel2 is empty but rawCategoryLevel2 exists (invalid IDs)
          apiParams.categoryLevel2 = newState.rawCategoryLevel2;
        } else if (apiParams.categoryLevel2 && apiParams.categoryLevel2.trim() === '') {
          // Remove empty categoryLevel2 from params
          delete apiParams.categoryLevel2;
        }
        if (apiParams.status) {
          const statusArray = apiParams.status.split(',');
          apiParams.status = statusArray.map(s => s === 'processing' ? 'is_processing' : s).join(',');
        }
        // Add pagination params
        const currentPage = page ? Number(page) : 1;
        apiParams.page = currentPage;
        apiParams.limit = this.state.pageLimit;
        
        // Fetch sessions
        const sessions = await getMySessions(apiParams);
        if (this._isMounted && sessions?.success) {
          const data = sessions.data.data;
          const allSessions = data.list || [];
          
          // Use sessions directly from API without frontend filtering to preserve pagination
          this.safeSetState({ 
            listSessions: allSessions,
            currentPage: data.currentPage || currentPage,
            totalRecords: Number(data.total) || 0,
          });
        }
      }
    });
    this.props.updatePageStatus('loaded');
    this.fetchPendingRatingSession();
  }

  fetchPendingRatingSession = async () => {
    const { user } = this.props;
    if (!user) return;
    try {
      const { fetchNeedEvaluateSessions } = this.props;
      const data = await fetchNeedEvaluateSessions();
      if (this._isMounted && data && data.length > 0) {
        this.safeSetState({ pendingRatingSession: data[0] });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    // Detect user type changes and refresh sessions
    const prevUserType = prevProps.user?.type || prevProps.user?.mvpUserType;
    const currentUserType = this.props.user?.type || this.props.user?.mvpUserType;
    
    if (prevUserType !== currentUserType) {
      // User type changed, refresh sessions
      const { getMySessions } = this.props;
      const params = this.mapUrlToFilter();
      
      // Build params for API call
      const apiParams = { ...params };
      const currentPage = params.page ? Number(params.page) : 1;
      apiParams.page = currentPage;
      apiParams.limit = this.state.pageLimit;
      
      // Map processing to is_processing for API
      if (apiParams.status) {
        const statusArray = apiParams.status.split(',');
        apiParams.status = statusArray.map(s => s === 'processing' ? 'is_processing' : s).join(',');
      }
      
      // Use filterCategoryLevel1 from state if available
      if (this.state.filterCategoryLevel1) {
        apiParams.categoryLevel1 = this.state.filterCategoryLevel1.value;
        delete apiParams.categoryId; // Prioritize categoryLevel1 over categoryId
      }
      
      // Use filterCategoryLevel2 from state if available
      if (this.state.filterCategoryLevel2 && this.state.filterCategoryLevel2.length > 0) {
        apiParams.categoryLevel2 = this.state.filterCategoryLevel2.map(c => c.value).join(',');
      } else if (this.state.rawCategoryLevel2 && this.state.rawCategoryLevel2.trim() !== '') {
        apiParams.categoryLevel2 = this.state.rawCategoryLevel2;
      }
      
      const sessions = await getMySessions(apiParams);
      if (this._isMounted && sessions?.success) {
        const data = sessions.data.data;
        const allSessions = data.list || [];
        this.safeSetState({ 
          listSessions: allSessions,
          currentPage: data.currentPage || currentPage,
          totalRecords: Number(data.total) || 0,
        });
      }
      return; // Don't process other updates
    }
    
    // Detect location.search changes and re-process URL params
    if (this.props.location.search !== prevProps.location.search) {
      // Location changed, re-process URL params similar to componentDidMount
      const params = this.mapUrlToFilter();
      const { categoryLevel1, categoryLevel2 } = params;
      
      if (categoryLevel1) {
        const level1Category = this.state.categoriesLevel1.find(cat => cat.key === categoryLevel1);
        if (level1Category) {
          const selectedCategory = this.state.categoriesWithChildren.find(cat => cat._id === categoryLevel1);
          if (selectedCategory && selectedCategory.children) {
            const newState = { filterCategoryLevel1: level1Category };
            
            // Treat empty string the same as null/undefined - default to all level 2
            if (categoryLevel2 && categoryLevel2.trim() !== '') {
              newState.rawCategoryLevel2 = categoryLevel2;
              const level2Ids = categoryLevel2.split(',');
              const level2Options = selectedCategory.children
                .filter(child => level2Ids.includes(child._id))
                .map(child => ({
                  key: child._id,
                  value: child._id,
                  label: this.getCategoryLabel(child),
                }));
              newState.filterCategoryLevel2 = level2Options.length > 0 ? level2Options : [];
            } else {
              const allLevel2 = selectedCategory.children.map(child => ({
                key: child._id,
                value: child._id,
                label: this.getCategoryLabel(child),
              }));
              newState.filterCategoryLevel2 = allLevel2;
              newState.rawCategoryLevel2 = null;
            }
            newState.categoriesLevel2 = selectedCategory.children.map(child => ({
              key: child._id,
              value: child._id,
              label: this.getCategoryLabel(child),
            }));
            
            this.safeSetState(newState);
            return; // Don't process filter changes yet, wait for state to update
          } else {
            // Category has no children, clear level 2
            this.safeSetState({
              filterCategoryLevel1: level1Category,
              filterCategoryLevel2: [],
              categoriesLevel2: [],
              rawCategoryLevel2: null
            }, () => {
              // Clear label of filterCategoryLevel2 when category has no sub categories
              this.clearFilterLabel('filterCategoryLevel2');
            });
            return;
          }
        }
      } else if (!categoryLevel1 && this.state.filterCategoryLevel1) {
        // categoryLevel1 was cleared
        this.safeSetState({
          filterCategoryLevel1: null,
          filterCategoryLevel2: [],
          categoriesLevel2: [],
          rawCategoryLevel2: null
        }, () => {
          // Clear label of filterCategoryLevel2 when category level 1 is cleared
          this.clearFilterLabel('filterCategoryLevel2');
        });
        return;
      }
    }
    
    // Check if I18n.language has changed (website language changed)
    const currentI18nLanguage = I18n.language || 'vi';
    const prevI18nLanguage = prevState.currentI18nLanguage || 'vi';
    const i18nLanguageChanged = currentI18nLanguage !== prevI18nLanguage;
    
    // Helper function to map language labels according to current website language
    const mapLanguageLabels = (listLanguage) => {
      if (!listLanguage || !listLanguage.length) return [];
      const currentLanguage = I18n.language || 'vi';
      return listLanguage.map(item => {
        let label = item.label;
        // If current website language is Vietnamese, show Vietnamese labels
        if (currentLanguage === 'vi') {
          label = item.value === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh';
        } else {
          // If current website language is English, show English labels
          label = item.value === 'en' ? 'English' : 'Vietnamese';
        }
        return {
          key: item.value,
          value: item.value,
          label: label,
        };
      });
    };
    
    // Re-map language labels if listLanguage changed OR I18n.language changed
    if (this.props.listLanguage !== prevProps.listLanguage || i18nLanguageChanged) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const language = searchParams.get('language');
      
      // Map language labels according to current website language
      const languages = mapLanguageLabels(this.props.listLanguage);
      this.safeSetState({ 
        languages: languages,
        currentI18nLanguage: currentI18nLanguage
      });
      
      // If I18n.language changed, update the labels of already-selected languages
      if (i18nLanguageChanged && this.state.filterLanguage && this.state.filterLanguage.length > 0) {
        const updatedFilterLanguage = this.state.filterLanguage.map(selectedLang => {
          const updatedLang = languages.find(l => l.value === selectedLang.value || l.key === selectedLang.value);
          return updatedLang || selectedLang;
        });
        this.safeSetState({ filterLanguage: updatedFilterLanguage });
      }
      
      // Set language filter: if in URL params, use it; otherwise default to all languages
      if (language) {
        const languageIds = language.split(',');
        const data = languages.filter(obj => languageIds.includes(obj.key));
        if (data.length > 0) {
          this.handleSelectMulti(data, 'filterLanguage', I18n.t('language'));
        }
      } else if (languages.length > 0) {
        // Default: select all languages
        this.handleSelectMulti(languages, 'filterLanguage', I18n.t('language'));
      }
    }

    const { filterCategories, filterEvaluating, filterKeySearch, filterCreateDate, filterStatus, filterRole, filterLanguage, filterCategoryLevel1, filterCategoryLevel2, isChangingCategoryLevel1 } = this.state;
    
    // Skip filter trigger if we're in the middle of changing categoryLevel1
    if (isChangingCategoryLevel1) {
      return;
    }
    
    const currentFilters = {
      filterCategories,
      filterEvaluating,
      filterKeySearch,
      filterCreateDate,
      filterRole,
      filterStatus,
      filterLanguage,
      filterCategoryLevel1,
      filterCategoryLevel2
    };
    const prevFilters = {
      filterCategories: prevState.filterCategories,
      filterEvaluating: prevState.filterEvaluating,
      filterKeySearch: prevState.filterKeySearch,
      filterCreateDate: prevState.filterCreateDate,
      filterRole: prevState.filterRole,
      filterStatus: prevState.filterStatus,
      filterLanguage: prevState.filterLanguage,
      filterCategoryLevel1: prevState.filterCategoryLevel1,
      filterCategoryLevel2: prevState.filterCategoryLevel2,
    };
    const handleToOther = prevState.filterCreateDate !== filterCreateDate && this.isOther()
    if (handleToOther) {
      return
    }
    if (!_.isEqual(currentFilters, prevFilters)) {
      await this.handleChangeDebounced();
    }
  }

  mapFilterToUrl = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    })

    this.props.history.push({ search: searchParams.toString() });
  }

  onPageChanged = async ({ currentPage }) => {
    this.setState({ currentPage });
    const { getMySessions } = this.props;
    const { filterEvaluating, filterCategories, filterKeySearch, filterCreateDate, filterStatus, filterRole, filterLanguage, filterCategoryLevel1, filterCategoryLevel2, rawCategoryLevel2, pageLimit } = this.state;

    // Use new category level 1 and level 2 filter if available, otherwise fallback to legacy categoryId
    let categoryId;
    let categoryLevel1;
    let categoryLevel2;
    
    if (filterCategoryLevel1) {
      categoryLevel1 = filterCategoryLevel1.value;
      if (filterCategoryLevel2 && filterCategoryLevel2.length > 0) {
        categoryLevel2 = filterCategoryLevel2.map(c => c.value).join(',');
      } else if (rawCategoryLevel2) {
        // Use raw value if filterCategoryLevel2 is empty (invalid IDs)
        categoryLevel2 = rawCategoryLevel2;
      }
      // Don't pass categoryId when categoryLevel1 is present
    } else if (filterCategories && filterCategories.length) {
      categoryId = filterCategories.map(c => c.value).join(',');
    }
    const role = filterRole?.value || null;
    let language = null;
    if (filterLanguage && filterLanguage.length) {
      // Only send language parameter if not all languages are selected
      const allLanguagesSelected = this.state.languages.length > 0 && 
        filterLanguage.length === this.state.languages.length &&
        filterLanguage.every(fl => this.state.languages.some(l => l.key === fl.key));
      
      // Only send language parameter if not all languages are selected
      if (!allLanguagesSelected) {
        language = filterLanguage.map(l => l.value).join(',');
      }
    }
    let status = null;
    if (filterStatus && filterStatus.length) {
      // Check if all statuses are selected by comparing with listStatus
      const allStatusesSelected = this.state.listStatus.length > 0 && 
        filterStatus.length === this.state.listStatus.length &&
        filterStatus.every(fs => this.state.listStatus.some(ls => ls.key === fs.key));
      
      // Only send status parameter if not all statuses are selected
      if (!allStatusesSelected) {
        status = filterStatus.map(c => c.value === 'processing' ? 'is_processing' : c.value).join(',');
      }
    }
    let evaluating = null;
    if (filterEvaluating && filterEvaluating.length) {
      evaluating = filterEvaluating.map(c => c.value).join(',');
    }
    const keySearch = filterKeySearch;
    let startDate, endDate;
    if (filterCreateDate && filterCreateDate.value) {
      const filterDate = this.getStartEndDate(filterCreateDate.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }

    const params = {};
    if (categoryId) params.categoryId = categoryId;
    if (categoryLevel1) params.categoryLevel1 = categoryLevel1;
    if (categoryLevel2) params.categoryLevel2 = categoryLevel2;
    if (evaluating) params.evaluating = evaluating;
    if (keySearch) params.keySearch = keySearch;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (status) params.status = status;
    if (role) params.role = role;
    if (language) params.language = language;
    params.page = currentPage;
    params.limit = pageLimit;
    this.mapFilterToUrl(params);
    
    const sessions = await getMySessions(params);
    if (this._isMounted && sessions.success) {
      const data = sessions.data.data;
      const allSessions = data.list || [];
      
      // Use sessions directly from API without frontend filtering to preserve pagination
      this.safeSetState({
        listSessions: allSessions,
        currentPage: data.currentPage || currentPage,
        totalRecords: Number(data.total) || 0,
      });
    }
  };

  mapUrlToFilter = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const categoryId = searchParams.get('categoryId');
    const categoryLevel1 = searchParams.get('categoryLevel1');
    const categoryLevel2 = searchParams.get('categoryLevel2');
    const evaluating = searchParams.get('evaluating');
    const keySearch = searchParams.get('keySearch');
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    const status = searchParams.get('status');
    const role = searchParams.get('role');
    const language = searchParams.get('language');
    const page = searchParams.get('page');
    return { categoryId, categoryLevel1, categoryLevel2, evaluating, keySearch, startDate, endDate, status, role, language, page }
  }

  handleSearchChange = async (e) => {
    const value = e.target.value.trim();
    this.setState({ filterKeySearch: value });
  };
  handleFilterDate = async (event) => {
    const {startDate, endDate} = this.state;
    if (this.isOther() && !startDate && !endDate) {
      await this.handleClearSelectDate(null)
    }
    await this.handleFilter(null)
    this.setState({ openFilterCreateDate: false })
  }
  handleStartTime = (value) => {
    const endDate = this.state.endDate?.valueOf() || null;
    if (endDate && endDate < value?.valueOf()) {
      this.setState({startDate: null})
      return
    }
    this.setState({startDate: value}, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          if (this.isOther()) {
            if (startDate && endDate) {
              title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
            } else if (startDate) {
              title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
            } else if (endDate) {
              title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
            }
          } else {
            title = `${filterCreateDate.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
    })
  }
  handleClearSelectDate = (event) => {
    if (event) {
      event.target.blur();
    }
    this.setState({
      filterCreateDate: null,
      startDate: null,
      endDate: null,
    });
  };
  handleEndTime = (value) => {
    const startDate = this.state.startDate?.valueOf() || null;
    if (startDate && value?.valueOf() < startDate) {
      this.setState({endDate: null})
      return
    }
    this.setState({endDate: value}, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          if (this.isOther()) {
            if (startDate && endDate) {
              title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
            } else if (startDate) {
              title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
            } else if (endDate) {
              title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
            }
          } else {
            title = `${title}: ${filterCreateDate.label}`;
          }
          spans[0].innerHTML = title;
          spans[0].setAttribute('title', title);
        }
      }
    })
  }
  handleSelectCreateDate = (value) => {
    if (!value) {
      this.handleClearSelectDate(null);
      return;
    }
    const state = { filterCreateDate: value }
    if (value !== 'other') {
      state.startDate = null
      state.endDate = null
    }

    this.setState(state, () => {
      const { filterCreateDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && filterCreateDate && filterCreateDate.value) {
          title = `${title}: ${filterCreateDate.label}`;
          spans[0].innerHTML = title;
        }
      }
    });
  };
  isOther = () => (this.state.filterCreateDate?.value === 'other')
  
  // API already returns name in the correct language based on accept-language header
  // So we just use category.name directly
  getCategoryLabel = (category) => {
    return category?.name || '';
  }
  handleDropdownVisibleChange = (open) => {
    this.safeSetTimeout(() => {
      if (!this._isMounted) return;
      if (this.isOther() && !open) {
        return
      }
      this.setState({ openFilterCreateDate: open });
    }, 0)
  };
  handleSelect = (value, select, label) => {
    if (!value) {
      this.handleClearSelect(null, select);
      return;
    }
    this.setState({ [select]: value }, () => {
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      if (element.length > 0 && element[0]) {
        let spans = element[0].querySelectorAll('.ant-select-selection-item');
        if (spans.length && selectedItems && selectedItems.value) {
          title = `${label}: ${selectedItems.label}`;
          spans[0].innerHTML = title;
        }
      }
    });
  };
  renderSelect = ({ label, select, options, onChange }) => {
    const selectedItems = this.state[select];
    const handleChange = onChange || ((value) => this.handleSelect(value, select, label));
    return (
      <Select
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        value={selectedItems}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        placeholder={label}
        onChange={handleChange}
        dropdownRender={menu => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (<div className="mtp-dropdown-footer">
              <div className="d-flex">
                <button onClick={(event) => this.handleClearSelect(event, select)} className="clear-all">
                  {I18n.t('clear_all')}
                </button>
                <button onClick={this.handleFilter} className="apply">{I18n.t('apply')}</button>
              </div>
            </div>) : null}
          </>
        )}
        options={options}
      />
    );
  };
  renderSelectDate = (options) => {
    const { filterCreateDate, openFilterCreateDate, startDate, endDate } = this.state;

    return (
      <Select
        className="createDate"
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        open={openFilterCreateDate}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={filterCreateDate}
        placeholder={I18n.t('dashboard_filter_date')}
        onChange={this.handleSelectCreateDate}
        dropdownStyle={{ width: '350px' }}
        dropdownRender={menu => (
          <>
            <div className="mtpd-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                {this.isOther() && (
                  <ConfigProvider locale={locale}>
                    <div className="d-flex justify-content-center align-content-center">
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleStartTime}
                        value={startDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                      <div className="d-flex align-items-center mr-2 ml-2" style={{color: '#9CA3AF', fontSize: '16px'}}>-</div>
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleEndTime}
                        value={endDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                    </div>
                  </ConfigProvider>
                )}
                <div className="d-flex">
                  <button
                    onClick={this.handleClearSelectDate}
                    className="clear-all">{I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilterDate} className="apply">{I18n.t('apply')}</button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };
  handleChangeDebounced = debounce(() => this.handleFilter(null), 500);
  getStartEndDate = (date) => {
    if (!date) {
      return { startDate: null, endDate: null };
    }
    let startDate, endDate;
    switch (date) {
      case 'today':
        startDate = moment().startOf('day');
        endDate = moment().endOf('day');
        break;

      case 'yesterday':
        startDate = moment().subtract(1, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;

      case 'thisWeek':
        startDate = moment().startOf('week').startOf('day');
        endDate = moment().endOf('week').endOf('day');
        break;

      case 'sevenDaysAgo':
        startDate = moment().subtract(7, 'days').startOf('day');
        endDate = moment().subtract(7, 'days').endOf('day');
        break;

      default:
        if (this.state.startDate) {
          startDate = moment(this.state.startDate).startOf('day');
        }
        if (this.state.endDate) {
          endDate = moment(this.state.endDate).endOf('day');
        }
        break;
    }

    return {
      startDate: startDate?.valueOf() || null,
      endDate: endDate?.valueOf() || null
    };
  };
  handleFilter = async (event) => {
    if (event) {
      event.target.blur();
    }

    const { filterEvaluating, filterCategories, filterKeySearch, filterCreateDate, filterStatus, filterRole, filterLanguage, filterCategoryLevel1, filterCategoryLevel2, rawCategoryLevel2 } = this.state;
    const { getMySessions } = this.props;

    // Use new category level 1 and level 2 filter if available, otherwise fallback to legacy categoryId
    let categoryId;
    let categoryLevel1;
    let categoryLevel2;
    
    if (filterCategoryLevel1) {
      categoryLevel1 = filterCategoryLevel1.value;
      if (filterCategoryLevel2 && filterCategoryLevel2.length > 0) {
        categoryLevel2 = filterCategoryLevel2.map(c => c.value).join(',');
      } else if (rawCategoryLevel2) {
        // Use raw value if filterCategoryLevel2 is empty (invalid IDs)
        categoryLevel2 = rawCategoryLevel2;
      }
      // Don't pass categoryId when categoryLevel1 is present
    } else if (filterCategories && filterCategories.length) {
      categoryId = filterCategories.map(c => c.value).join(',');
    }
    const role = filterRole?.value || null;
    let language = null;
    if (filterLanguage && filterLanguage.length) {
      // Only send language parameter if not all languages are selected
      const allLanguagesSelected = this.state.languages.length > 0 && 
        filterLanguage.length === this.state.languages.length &&
        filterLanguage.every(fl => this.state.languages.some(l => l.key === fl.key));
      
      // Only send language parameter if not all languages are selected
      if (!allLanguagesSelected) {
        language = filterLanguage.map(l => l.value).join(',');
      }
    }
    let status = null;
    if (filterStatus && filterStatus.length) {
      // Check if all statuses are selected by comparing with listStatus
      const allStatusesSelected = this.state.listStatus.length > 0 && 
        filterStatus.length === this.state.listStatus.length &&
        filterStatus.every(fs => this.state.listStatus.some(ls => ls.key === fs.key));
      
      // Only send status parameter if not all statuses are selected
      if (!allStatusesSelected) {
        // Map processing back to is_processing for API compatibility
        status = filterStatus.map(c => c.value === 'processing' ? 'is_processing' : c.value).join(',');
      }
    }
    let evaluating = null;
    if (filterEvaluating && filterEvaluating.length) {
      evaluating = filterEvaluating.map(c => c.value).join(',');
    }
    const keySearch = filterKeySearch;
    let startDate, endDate;
    if (filterCreateDate && filterCreateDate.value) {
      const filterDate = this.getStartEndDate(filterCreateDate.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }
    // Reset to page 1 when filter changes
    const params = {};
    if (categoryId) params.categoryId = categoryId;
    if (categoryLevel1) params.categoryLevel1 = categoryLevel1;
    if (categoryLevel2) params.categoryLevel2 = categoryLevel2;
    if (evaluating) params.evaluating = evaluating;
    if (keySearch) params.keySearch = keySearch;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (status) params.status = status;
    if (role) params.role = role;
    if (language) params.language = language;
    params.page = 1;
    params.limit = this.state.pageLimit;
    this.mapFilterToUrl(params);
    const sessions = await getMySessions(params);
    if (this._isMounted && sessions.success) {
      const data = sessions.data.data;
      const allSessions = data.list || [];
      
      // Use sessions directly from API without frontend filtering to preserve pagination
      this.safeSetState({
        listSessions: allSessions,
        currentPage: data.currentPage || 1,
        totalRecords: Number(data.total) || 0,
      });
    }
  };

  handleClearSelect = (event, select) => {
    if (event) {
      event.target.blur();
    }
    // For category level 2, prevent clearing all when category level 1 is selected
    if (select === 'filterCategoryLevel2' && this.state.filterCategoryLevel1) {
      // Keep at least the first available option
      const firstOption = this.state.categoriesLevel2 && this.state.categoriesLevel2.length > 0 
        ? [this.state.categoriesLevel2[0]] 
        : [];
      if (firstOption.length > 0) {
        this.setState({ [select]: firstOption }, () => {
          let element = document.querySelectorAll(`.${select}  .ant-select-selector label`);
          if (element.length) {
            element[0].remove();
          }
          this.updateFilterLabel(select, I18n.t('session_category_level2') || 'Sub Category');
          element = null;
        });
      }
      return;
    }
    this.setState({ [select]: null },() => {
      let element = document.querySelectorAll(`.${select}  .ant-select-selector label`);
      if (element.length) {
        element[0].remove();
      }
      element = null;
    });
  };
  renderSelectMulti = ({ label, select, options, disabled }) => {
    const selectedItems = this.state[select];
    // Disable "Clear All" button for category level 2 when category level 1 is selected and only 1 item remains
    const isClearAllDisabled = select === 'filterCategoryLevel2' && 
      this.state.filterCategoryLevel1 && 
      selectedItems && 
      selectedItems.length === 1;
    return (
      <Select
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        mode="multiple"
        disabled={disabled}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={selectedItems}
        placeholder={label}
        onChange={(value) => this.handleSelectMulti(value, select, label)}
        dropdownRender={menu => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (<div className="mtp-dropdown-footer">
              <div className="d-flex">
                <button 
                  onClick={(event) => this.handleClearSelect(event, select)} 
                  className="clear-all"
                  disabled={isClearAllDisabled}
                  style={isClearAllDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                >
                  {I18n.t('clear_all')}
                </button>
                <button onClick={this.handleFilter} className="apply">{I18n.t('apply')}</button>
              </div>
            </div>) : null}
          </>
        )}
        options={options}
      />
    );
  };

  clearFilterLabel = (select) => {
    let element = document.querySelectorAll(`.${select} .ant-select-selector`);
    if (element.length > 0 && element[0]) {
      let spans = element[0].querySelectorAll('label');
      if (spans.length) {
        spans.forEach(span => span.remove());
      }
    }
  };

  updateFilterLabel = (select, label) => {
    const selectedItems = this.state[select];
    let title = label;
    let element = document.querySelectorAll(`.${select} .ant-select-selector`);
    if (element.length > 0 && element[0]) {
      let spans = element[0].querySelectorAll('label');
      if (spans.length) {
        spans.forEach(span => span.remove());
      }
      // Only add label if there are selected items
      // If selectedItems is null, undefined, empty array, or has no length, label will remain cleared
      if (selectedItems && selectedItems.length && selectedItems.length > 0) {
        // Special handling for language filter: show "Language: 2 choice" when 2 languages selected
        if (select === 'filterLanguage' && selectedItems.length === 2) {
          title = `${label}: 2 ${I18n.t('choice')}`;
        } else if (select === 'filterCategoryLevel2') {
          title = `${label}: ${selectedItems.length} ${I18n.t('choice')}`;
        } else if (selectedItems.length > 1) {
          title = `${label}: ${selectedItems.length} ${I18n.t('choice')}`;
        } else {
          title = `${label}: ${selectedItems[0].label}`;
        }
        element[0].innerHTML += `<label>${title}</label>`;
      }
      // If no selected items, label is already cleared above, so placeholder will show
    }
  };

  handleSelectMulti = (value, select, label) => {
    // For category level 2, prevent clearing all when category level 1 is selected
    if (select === 'filterCategoryLevel2' && this.state.filterCategoryLevel1) {
      // Must have at least 1 selection when category level 1 is selected
      if (!value || !value.length) {
        // Keep at least the first available option if trying to clear all
        const firstOption = this.state.categoriesLevel2 && this.state.categoriesLevel2.length > 0 
          ? [this.state.categoriesLevel2[0]] 
          : [];
        if (firstOption.length > 0) {
          this.setState({ [select]: firstOption }, () => {
            this.updateFilterLabel(select, label);
          });
        }
        return;
      }
    }
    
    if (!value || !value.length) {
      this.handleClearSelect(null, select);
      return;
    }
    this.setState({ [select]: value }, () => {
      this.updateFilterLabel(select, label);
    });
  };

  handleSelectCategoryLevel1 = (value, select, label) => {
    if (!value) {
      this.setState({ 
        filterCategoryLevel1: null,
        filterCategoryLevel2: [],
        categoriesLevel2: [],
        rawCategoryLevel2: null
      }, () => {
        this.handleClearSelect(null, select);
        // Clear label of filterCategoryLevel2 when category level 1 is cleared
        this.clearFilterLabel('filterCategoryLevel2');
      });
      return;
    }
    
    // Find selected category with children
    const selectedCategory = this.state.categoriesWithChildren.find(cat => cat._id === value.value);
    
    // Check if categoryLevel1 is actually changing
    const isChanging = !this.state.filterCategoryLevel1 || this.state.filterCategoryLevel1.value !== value.value;
    
    if (selectedCategory && selectedCategory.children) {
      const allLevel2 = selectedCategory.children.map(child => ({
        key: child._id,
        value: child._id,
        label: this.getCategoryLabel(child),
      }));
      
      // When changing categoryLevel1, clear categoryLevel2 first and trigger filter with only categoryLevel1
      if (isChanging) {
        // First, clear categoryLevel2 and set only categoryLevel1, then trigger filter
        this.setState({ 
          [select]: value,
          filterCategoryLevel2: [],
          rawCategoryLevel2: null,
          categoriesLevel2: allLevel2,
          isChangingCategoryLevel1: true // Set flag to prevent filter trigger
        }, async () => {
          this.updateFilterLabel(select, label);
          // Clear old label of filterCategoryLevel2 before setting new one
          this.clearFilterLabel('filterCategoryLevel2');
          // Trigger filter immediately with only categoryLevel1 (no categoryLevel2)
          await this.handleFilter(null);
          // After filter is done, wait a bit then set all level 2 as selected (but don't trigger filter again)
          // Use setTimeout to ensure componentDidUpdate has finished processing the previous state change
          this.safeSetTimeout(() => {
            if (!this._isMounted) return;
            // Keep flag true when setting level 2 to prevent filter trigger
            this.safeSetState({
              filterCategoryLevel2: allLevel2
            }, () => {
              if (!this._isMounted) return;
              // Clear flag after a short delay to allow componentDidUpdate to process
              this.safeSetTimeout(() => {
                if (this._isMounted) {
                  this.safeSetState({
                    isChangingCategoryLevel1: false
                  });
                }
              }, 50);
              // Update label for category level 2 filter
              if (allLevel2.length > 0) {
                this.safeSetTimeout(() => {
                  if (this._isMounted) {
                    this.updateFilterLabel('filterCategoryLevel2', I18n.t('session_category_level2') || 'Sub Category');
                  }
                }, 100);
              }
            });
          }, 100);
        });
      } else {
        // Same categoryLevel1, just update level 2 options
        this.setState({ 
          [select]: value,
          filterCategoryLevel2: allLevel2,
          categoriesLevel2: allLevel2
        }, () => {
          this.updateFilterLabel(select, label);
          // Update label for category level 2 filter
          if (allLevel2.length > 0) {
            this.safeSetTimeout(() => {
              if (this._isMounted) {
                this.updateFilterLabel('filterCategoryLevel2', I18n.t('session_category_level2') || 'Sub Category');
              }
            }, 100);
          }
        });
      }
    } else {
      // Category has no children, just set level 1 and clear level 2
      this.setState({ 
        [select]: value,
        filterCategoryLevel2: [],
        rawCategoryLevel2: null,
        categoriesLevel2: []
      }, async () => {
        this.updateFilterLabel(select, label);
        // Clear label of filterCategoryLevel2 when category has no sub categories
        this.clearFilterLabel('filterCategoryLevel2');
        // Trigger filter with only categoryLevel1
        if (isChanging) {
          await this.handleFilter(null);
        }
      });
    }
  };

  render() {
    const { languages, filterKeySearch, listSessions, categories, categoriesLevel1, categoriesLevel2, evaluating, createDate, listStatus, roles, totalRecords, pageLimit, currentPage, filterCategoryLevel1, filterCategoryLevel2 } = this.state
    const {user} = this.props
    
    return (
      <div id="site_wrapper">
        <div className="site-upper">
          {this.props.header}
          <div style={this.style} className="page-hero-cus">
            <PageHero description={I18n.t('my_session')}/>
          </div>
        </div>
        <main className="main">
          <div className="container">
            {/*<canvas id="dotlottie-canvas"/>*/}
            {/*<DotLottieReact*/}
            {/*  // src={animate}*/}
            {/*  loop*/}
            {/*  autoplay*/}
            {/*  width="400px"*/}
            {/*  height="400px"*/}
            {/*/>*/}
            <PageLoader loading={!listSessions} />
            {listSessions && (
              <Section
                title=""
                url="/"
                className="card-section"
              >
                <div className="mtp-filter-zone">
                  <div className="search">
                    <FontAwesomeIcon className="cursor-pointer" icon={faSearch}
                                     style={{ fontSize: '18px', color: '#9CA3AF' }} />
                    <input value={filterKeySearch} onChange={this.handleSearchChange}
                           placeholder={I18n.t('my_dashboard_topic_search_hint_text')} />
                  </div>
                  <div className="select">
                    {this.renderSelectMulti({
                      label: I18n.t('dashboard_filter_status'),
                      select: 'filterStatus',
                      options: listStatus,
                    })}
                    {this.renderSelectDate(createDate)}
                    { user && user.type === 'guide' && (this.renderSelect({
                      label: I18n.t('dashboard_filter_provider'),
                      select: 'filterRole',
                      options: roles,
                    }))}
                    {this.renderSelect({
                      label: I18n.t('session_category_label_required'),
                      select: 'filterCategoryLevel1',
                      options: categoriesLevel1,
                      onChange: (value) => this.handleSelectCategoryLevel1(value, 'filterCategoryLevel1', I18n.t('session_category_label_required')),
                    })}
                    {this.renderSelectMulti({
                      label: I18n.t('session_category_level2') || 'Sub Category',
                      select: 'filterCategoryLevel2',
                      options: categoriesLevel2 && categoriesLevel2.length > 0 ? categoriesLevel2 : [],
                      disabled: !filterCategoryLevel1 || !categoriesLevel2 || categoriesLevel2.length === 0,
                    })}
                    {/* {this.renderSelectMulti({
                      label: I18n.t('rating'),
                      select: 'filterEvaluating',
                      options: evaluating,
                    })} */}
                    {languages && languages.length > 0 && this.renderSelectMulti({
                      label: I18n.t('language'),
                      select: 'filterLanguage',
                      options: languages,
                    })}
                  </div>
                </div>
                <div className="row">
                  {listSessions.map((item, index) => {
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <CardMvpSession
                          key={index}
                          data={item}
                          status={item.status}
                          url={config.sites.bounty}
                          user={this.props.user}
                        />


                      </div>

                    );
                  })}
                </div>
                {totalRecords > 0 && (
                  <Pagination
                    totalRecords={totalRecords}
                    pageLimit={pageLimit}
                    pageNeighbours={1}
                    onPageChanged={this.onPageChanged}
                  />
                )}
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}
        {this.state.pendingRatingSession && (
          <RatingFloatNotification
            session={this.state.pendingRatingSession}
            onDismiss={() => this.safeSetState({ pendingRatingSession: null })}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  listLanguage: state.mvp.listLanguage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMySessions,
      updatePageStatus,
      getCategorySessions,
      getListStatusSession,
      getListBuddyRole,
      fetchNeedEvaluateSessions,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MySession);
